/* tslint:disable */
/* eslint-disable */
/* @relayHash d9d99e779d0465c8928c15e9de24e204 */

import { ConcreteRequest } from "relay-runtime";
export type BanUserInput = {
    userID: string;
    clientMutationId: string;
    message: string;
    rejectExistingComments?: boolean | null;
};
export type BanUserMutationVariables = {
    input: BanUserInput;
};
export type BanUserMutationResponse = {
    readonly banUser: {
        readonly user: {
            readonly id: string;
            readonly status: {
                readonly ban: {
                    readonly active: boolean;
                };
                readonly suspension: {
                    readonly active: boolean;
                };
                readonly warning: {
                    readonly active: boolean;
                };
                readonly premod: {
                    readonly active: boolean;
                };
            };
        };
        readonly clientMutationId: string;
    };
};
export type BanUserMutation = {
    readonly response: BanUserMutationResponse;
    readonly variables: BanUserMutationVariables;
};



/*
mutation BanUserMutation(
  $input: BanUserInput!
) {
  banUser(input: $input) {
    user {
      id
      status {
        ban {
          active
        }
        suspension {
          active
        }
        warning {
          active
        }
        premod {
          active
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
        } as any)
    ], v2 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "BanUserPayload",
            "kind": "LinkedField",
            "name": "banUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": (v1 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SuspensionStatus",
                                    "kind": "LinkedField",
                                    "name": "suspension",
                                    "plural": false,
                                    "selections": (v1 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WarningStatus",
                                    "kind": "LinkedField",
                                    "name": "warning",
                                    "plural": false,
                                    "selections": (v1 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PremodStatus",
                                    "kind": "LinkedField",
                                    "name": "premod",
                                    "plural": false,
                                    "selections": (v1 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "BanUserMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "BanUserMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "d9d99e779d0465c8928c15e9de24e204",
            "metadata": {},
            "name": "BanUserMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '4c38342d23851e3e5806975a1b58d8d2';
export default node;
